require('./bootstrap');

import CitySelectorModal  from './components/city-selector-modal';
import Tariff from "./components/tariff";
import { dynamicMask } from './components/phone-mask';

import ButtonHandler from "./components/button-handler";
import ModalHandler from "./components/modal-handler";
import UtmSetter from "./lib/utm-setter"
import CityCheck from './components/city-check';
import { gobletPopover, aboutPopover, tariffPopover} from "./components/popovers"; // bug

import FooterMenu from "./components/footer-menu";

import SomeStuff from "./components/some-stuff";
import Tab from "bootstrap/js/src/tab";
import Collapse from "bootstrap/js/src/collapse";

const citySelector = new CitySelectorModal(); // vanilla
const tariff = new Tariff(); // vanilla
const buttonHandler = new ButtonHandler(); // vanilla
const modalHandler = new ModalHandler(); // vanilla
const cityCheck = new CityCheck(); // vanilla // vanilla
gobletPopover();
aboutPopover();
tariffPopover();
const footer = new FooterMenu(); // vanilla
const someStuff = new SomeStuff(); // vanilla


